module.exports = __webpack_public_path__ + "img/18_82.e1da341b.png";